/*!
 *
 *	menu.js
 *
 */

var menu = {
	init: function(){
		this.$btn = $('#menu_btn a');
		this.$inner = $('#menu_inner');
		this.$menu = $('#header_menu');
		this.event();
	},
	event: function(){
		var self = this;
		var isClose = true;
		self.$btn.on('click', function(e){
			e.preventDefault();
			isClose = !isClose;
			self.$menu.stop().slideToggle(500, function() {
				if (isClose) {
					self.$menu.removeAttr('style');
				}
			});
			self.$btn.parent().toggleClass('active');
		})
		origin.$window.on('changePC', function() {
			if (isClose) return;
			isClose = true;
			self.$btn.parent().toggleClass('active');
			self.$menu.removeAttr('style');
		})
	},
};

module.exports = menu;



//////////////////
// WEBPACK FOOTER
// ./dev/dcms_media/js/components/module/menu.js
// module id = 16
// module chunks = 0